'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ipRegex = require('ip-regex');

var ipRegex = _interopRequireWildcard(_ipRegex);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _IrcdDiffs = require('@/helpers/IrcdDiffs');

var IrcdDiffs = _interopRequireWildcard(_IrcdDiffs);

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: ['buffer', 'network', 'user'],
    data: function data() {
        return {
            whoisRequested: false,
            whoisLoading: false
        };
    },
    computed: {
        availableChannelModes: function availableChannelModes() {
            var availableModes = [];
            var prefixes = this.network.ircClient.network.options.PREFIX;
            var knownPrefix = {
                q: 'Owner',
                a: 'Admin',
                o: 'Operator',
                h: 'Half-Operator',
                v: 'Voice'
            };

            if (!IrcdDiffs.isAChannelModeAdmin(this.network)) {
                delete knownPrefix.a;
            }
            if (!IrcdDiffs.isQChannelModeOwner(this.network)) {
                delete knownPrefix.q;
            }
            if (!IrcdDiffs.supportsHalfOp(this.network)) {
                delete knownPrefix.h;
            }

            prefixes.forEach(function (prefix) {
                var mode = prefix.mode;
                if (knownPrefix[mode]) {
                    availableModes.push({
                        mode: mode,
                        description: knownPrefix[mode]
                    });
                }
            });

            return availableModes;
        },
        areWeAnOp: function areWeAnOp() {
            if (!this.buffer) {
                return false;
            }

            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
        },
        isUserOnBuffer: function isUserOnBuffer() {
            if (!this.buffer) {
                return false;
            }

            if (!this.user.buffers[this.buffer.id]) {
                return false;
            }

            return true;
        },
        userMode: {
            get: function getUserMode() {
                if (!this.buffer) {
                    return '';
                }

                var userBufferInfo = this.user.buffers[this.buffer.id];
                if (!userBufferInfo) {
                    return '';
                }

                var modes = userBufferInfo.modes;
                return modes.length > 0 ? modes[0] : '';
            },

            set: function setUserMode(newVal) {
                var client = this.network.ircClient;
                var oldVal = this.userMode;

                var changes = [];
                var targets = [];

                if (oldVal) {
                    changes.push('-' + oldVal);
                    targets.push(this.user.nick);
                }
                if (newVal) {
                    changes.push('+' + newVal);
                    targets.push(this.user.nick);
                }

                var params = ['MODE', this.buffer.name, changes.join('')].concat(targets);
                client.raw(params);
            }
        },
        userChannels: function userChannels() {
            var channels = this.user.channels.trim().split(' ');
            for (var i = 0; i < channels.length; i++) {
                channels[i] = TextFormatting.linkifyChannels(channels[i]);
            }
            return channels.join(' ');
        },
        isSelf: function isSelf() {
            return this.user === this.network.currentUser();
        }
    },
    watch: {
        user: function watchUser() {
            this.whoisRequested = false;
            this.whoisLoading = false;
        }
    },
    methods: {
        userModeOnThisBuffer: function userModeOnBuffer(user) {
            if (!this.buffer) {
                return '';
            }

            var userBufferInfo = user.buffers[this.buffer.id];
            var modes = userBufferInfo.modes;
            return modes.length > 0 ? modes[0] : '';
        },
        openQuery: function openQuery() {
            var buffer = this.$state.addBuffer(this.network.id, this.user.nick);
            this.$state.setActiveBuffer(this.network.id, buffer.name);
            if (this.$state.ui.is_narrow) {
                this.$state.$emit('userbox.hide');
            }
        },
        onChannelsClick: function onChannelsClick(event) {
            var channelName = event.target.getAttribute('data-channel-name');
            if (channelName) {
                var network = this.buffer.getNetwork();
                this.$state.addBuffer(this.buffer.networkid, channelName);
                network.ircClient.join(channelName);
            }
        },

        updateWhoisData: function updateWhoisData() {
            var _this = this;

            this.whoisRequested = true;
            this.whoisLoading = true;
            this.network.ircClient.whois(this.user.nick, function () {
                _this.whoisLoading = false;
            });
        },
        kickUser: function kickUser() {
            var reason = this.$state.setting('buffers.default_kick_reason');
            this.network.ircClient.raw('KICK', this.buffer.name, this.user.nick, reason);
        },
        createBanMask: function createBanMask() {
            if (this.user.account) {
                var extban = IrcdDiffs.extbanAccount(this.network);
                if (extban) {
                    return extban + ':' + this.user.account;
                }

                if (this.user.host.toLowerCase().indexOf(this.user.account.toLowerCase()) > -1) {
                    return '*!*@' + this.user.host;
                }
            }

            var ipTest = new RegExp('(' + ipRegex.v4().source + '|' + ipRegex.v6().source + ')');
            if (ipTest.test(this.user.host)) {
                var match = this.user.host.match(ipTest)[0];
                if (match !== this.user.host) {
                    return '*!*@*' + match + '*';
                }
            }

            var hexTest = /^([a-f0-9]{8})$/i;
            if (hexTest.test(this.user.username)) {
                var _match = this.user.username.match(hexTest)[0];
                return '*!' + _match + '@*';
            }

            var mask = this.$state.setting('buffers.default_ban_mask');
            mask = mask.replace('%n', this.user.nick);
            mask = mask.replace('%i', this.user.username);
            mask = mask.replace('%h', this.user.host);

            return mask;
        },
        banUser: function banUser() {
            if (!this.user.username || !this.user.host) {
                return;
            }

            var banMask = this.createBanMask();
            this.network.ircClient.raw('MODE', this.buffer.name, '+b', banMask);
        },
        kickbanUser: function kickbanuser() {
            if (!this.user.username || !this.user.host) {
                return;
            }

            var banMask = this.createBanMask();
            var reason = this.$state.setting('buffers.default_kick_reason');
            this.network.ircClient.raw('MODE', this.buffer.name, '+b', banMask);
            this.network.ircClient.raw('KICK', this.buffer.name, this.user.nick, reason);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserBox"]
window._kiwi_exports.components.UserBox = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserBox.vue
// module id = kyKn
// module chunks = 1